// extracted by mini-css-extract-plugin
module.exports = {"main":"Radio_main__2FGGr","radio_btn":"Radio_radio_btn__2OXWH","icon":"Radio_icon__3Ty3u","checked":"Radio_checked__2MnEo","disable":"Radio_disable__2f7dt"};